//Summary
import React, {Component} from 'react';
import {connect} from "react-redux";
import $ from 'jquery';

import {Link} from 'react-router-dom';

import styled from "styled-components";

import {getSummary, getAttrOptionsByParams, getOptionsDeliveryTime, getAttrLink} from "../../helpers/attributes";

import TotalInfo from "../../components/TotalInfo"
import ContactBox from "../ContactBox";

//import VariantBox from "../VariantBox";
import Modal from "../Modal";
import Loader from "../Loader";
import axios from "axios";
import config from '../../config'

import {ReactComponent as YesGreenIcon} from '../../assets/img/yes-green-icon.svg';

import './index.scss';

const StyledContactBox = styled(ContactBox)`
  margin-bottom: 26px;
`;

class Summary extends Component {

    state = {
        infoModal: false,
        infoLoading: false,
        infoContent: '',
    };

    handleCloseInfoModal = (e) => {
        e.stopPropagation();

        this.setState({
            infoModal: false
        });

        if (this.infoLoadingCancel) {
            this.infoLoadingCancel();
        }

    };

    handleOpenInfoModal = (e) => {
        e.stopPropagation();

        const shortcode = '[block id="merkmale-eichentische"]';

        if (!shortcode) {
            return;
        }

        /*
        if (shortcode === lastInfoShortcode) {
            this.setState({
                infoModal: true
            });
            return;
        }*/

        this.setState({
            infoContent: "",
            infoLoading: true,
            infoModal: true,
        });

        const CancelToken = axios.CancelToken;
        const source = CancelToken.source();
        this.infoLoadingCancel = source.cancel;

        axios.get(`${config.apiBase}/shortcode/`, {
            cancelToken: source.token,
            params: {
                shortcode
            }
        }).then(response => {

            console.log(response);

            this.setState({
                infoLoading: false,
                infoContent: response.data,
            });

            $('.accordion-title').click(function(e) {
                e.preventDefault();

                var $this = $(this);

                if ($this.next().hasClass('show')) {
                    $this.removeClass('active');
                    $this.next().removeClass('show');
                    $this.next().slideUp(350);
                } else {
                    $this.parent().parent().find('a.accordion-title').removeClass('active');
                    $this.parent().parent().find('div.accordion-inner').removeClass('show');
                    $this.parent().parent().find('div.accordion-inner').slideUp(350);
                    $this.addClass('active');
                    $this.next().toggleClass('show');
                    $this.next().slideToggle(350);
                }
            });


        }, () => {
            this.setState({
                infoLoading: false,
            });
        });

    };

    render(){

        const {infoModal, infoContent, infoLoading} = this.state;

        const {attributes, params, deliveryTime, history} = this.props,
            summary = getSummary(attributes, params),
            selectedOptions = getAttrOptionsByParams(attributes, params),
            optionsDeliveryTime = getOptionsDeliveryTime(selectedOptions);


        return (
            <div className="summary">

                <div className="summary__header">
                    <YesGreenIcon className="summary__yes-icon"/>
                    <div className="summary__heading">Dein Tisch ist fertig konfiguriert.</div>
                </div>


                <div className="summary__items">
                    {summary.map((item, key) => (
                        <Link
                            className="summary__item"
                            key={key}
                            to={{
                                pathname: getAttrLink(item.slug),
                                state: {
                                    prev: history.location.pathname
                                }
                            }}>
                            <div className="summary__item-title">{item.name}</div>
                            <div className="summary__item-value">
                                {item.valueName}
                                {item.subValueName && <div className="summary__item-sub-value">{item.subValueName}</div>}

                                {item.additional && item.additional.map((subItem, key) =>
                                    <div className="summary__item-sub-value" key={key}>{subItem.valueName}</div>
                                )}

                                {item.slug === 'sizes' &&
                                    <div className="summary__item-sub-value">76 cm hoch</div>
                                }

                            </div>
                        </Link>
                    ))}
                </div>

                <div className="summary__note">
                    <b>Jeder Tisch ein Unikat:</b> Dein Steiger-Tisch ist ein echtes Naturprodukt. Deswegen beachte bitte, dass jede
                    Tischplatte etwas anders aussieht hinsichtlich Astlöchern, Rissbildungen und Jahresringen.

                    <b><a href="#" onClick={this.handleOpenInfoModal}>Hier</a> findest du alle Merkmale deiner Tischplatte.</b>


                    <Modal
                        isOpen={infoModal}
                        onRequestClose={this.handleCloseInfoModal}
                    >
                        {infoLoading ?
                            <Loader/>
                            :
                            <div dangerouslySetInnerHTML={{__html: infoContent}}/>
                        }
                    </Modal>

                </div>

                <TotalInfo className="summary__total-info"/>

                <div className="summary__delivery-time">
                    {
                        deliveryTime
                        //'Lieferzeit: 6 Wochen'
                    }
                </div>

                <div className="summary__delivery-cost">
                    <YesGreenIcon className="summary__delivery-cost-icon"/>
                    Kostenloser Versand und Aufbau
                </div>

                <StyledContactBox/>

            </div>
        );

    }


 
};

export default connect(
  state => ({
    params: state.params,
    attributes: state.attributes,
    deliveryTime: state.productData.deliveryTime
  })
)(Summary);
